import {css} from '@yandex-delivery/blocks/theme/css'

export const classes = {
  pointer: css`
    cursor: pointer;
  `,
  disabled: css`
    opacity: 0.6;
    pointer-events: none;
  `,
  body: css`
    &&&& {
      padding-inline-start: 0; // Переопределил свойство у <Text> компонента
    }
  `,
}
